import {
  Typography,
  Divider,
  Breadcrumbs,
  Link as MuiLink,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ROUTES } from "../../constants";
import { Helmet } from "react-helmet-async";

const forms = [
  {
    title: "Well Construction Notification Application",
    description:
      "Submit a new well registration form to the district. Required before drilling or altering a well.",
    route: ROUTES.NEW_WELL_REGISTRATION,
  },
  {
    title: "Existing Well Registration Request",
    description: "Register an existing well with the District.",
    route: ROUTES.EXISTING_WELL_REGISTRATION,
  },
  {
    title: "Water Service Connection Form",
    description: "Request a new water service connection.",
    route: ROUTES.NEW_WATER_SERVICE_CONNECTION,
  },
];

export default function PublicForms() {
  return (
    <>
      <Helmet>
        <title>Public Forms</title>
      </Helmet>

      <Typography variant="h3" gutterBottom display="inline">
        Public Forms
      </Typography>
      <Breadcrumbs sx={{ mt: 4 }} aria-label="Breadcrumb">
        <MuiLink component={RouterLink} to={ROUTES.LANDING}>
          Home
        </MuiLink>
        <Typography>Forms</Typography>
      </Breadcrumbs>
      <Divider sx={{ my: 6 }} />

      <Grid container spacing={4}>
        {forms.map((form) => (
          <Grid item key={form.title} xs={12} sm={6} md={4}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {form.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {form.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  component={RouterLink}
                  to={form.route}
                  variant="contained"
                  color="secondary"
                  size="small"
                >
                  Open Form
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
